/**
 * MegaMenuTabs — Custom element for tabbed mega menu navigation.
 * Handles tab switching on click/hover, keyboard navigation (WAI-ARIA tabs pattern).
 */
class MegaMenuTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');
    this.hoverTimeout = null;
    this.bindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchTab(tab);
      });

      tab.addEventListener('keydown', (e) => this.handleKeydown(e));

      tab.addEventListener('mouseenter', () => {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = setTimeout(() => this.switchTab(tab), 150);
      });
    });

    this.addEventListener('mouseleave', () => {
      clearTimeout(this.hoverTimeout);
    });
  }

  switchTab(selectedTab) {
    this.tabs.forEach((tab) => {
      tab.classList.remove('mega-tabs__tab--active');
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('tabindex', '-1');
    });

    this.panels.forEach((panel) => {
      panel.classList.remove('mega-tabs__panel--active');
      panel.hidden = true;
    });

    selectedTab.classList.add('mega-tabs__tab--active');
    selectedTab.setAttribute('aria-selected', 'true');
    selectedTab.setAttribute('tabindex', '0');

    const panelId = selectedTab.getAttribute('aria-controls');
    const panel = this.querySelector('#' + panelId);
    if (panel) {
      panel.classList.add('mega-tabs__panel--active');
      panel.hidden = false;
    }
  }

  handleKeydown(e) {
    const tabArray = Array.from(this.tabs);
    const index = tabArray.indexOf(e.currentTarget);
    let newIndex;

    switch (e.key) {
      case 'ArrowRight':
        newIndex = (index + 1) % tabArray.length;
        break;
      case 'ArrowLeft':
        newIndex = (index - 1 + tabArray.length) % tabArray.length;
        break;
      case 'Home':
        newIndex = 0;
        break;
      case 'End':
        newIndex = tabArray.length - 1;
        break;
      default:
        return;
    }

    e.preventDefault();
    tabArray[newIndex].focus();
    this.switchTab(tabArray[newIndex]);
  }
}

customElements.define('mega-menu-tabs', MegaMenuTabs);
